import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  InvestDetailOperationAgent,
  InvestDetailOperationTotals,
  InvestmentDetailsOperation,
} from '@app/control-panel/models/control-panel.model';

@Component({
  selector: 'scf-invest-detail-table',
  templateUrl: './invest-detail-table.component.html',
  styleUrls: ['./invest-detail-table.component.scss'],
})
export class InvestDetailTableComponent implements OnInit, AfterViewInit {
  @Input() data: InvestDetailOperationAgent;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isTableHidden: boolean = false;

  isFirstPage: boolean = true;
  isLastPage: boolean = false;
  page: number = 0;

  displayedColumns: string[] = [
    'seller',
    'code',
    'client',
    'prod',
    'dateForm',
    'investment',
    'tin',
    'incentive',
    'term',
    'type',
    'brand',
    'model',
    'prot',
    'rapp',
  ];

  dataSource = new MatTableDataSource<InvestmentDetailsOperation>();
  totals: InvestDetailOperationTotals;

  constructor(private cdref: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.dataSource.data = this.data?.dataGroup;
    this.totals = this.data?.totals;
    this.totals.totalIncent = +this.totals.totalIncent.toFixed(2);
    this.totals.totalInvest = +this.totals.totalInvest.toFixed(2);
  }

  displayCard(): void {
    this.isTableHidden = !this.isTableHidden;
    this.cdref.detectChanges();
    this.dataSource.paginator = this.paginator;
  }

  savePage(event: any): void {
    this.page = event?.pageIndex;
  }
}
